import { render, staticRenderFns } from "./NewDetailCasesAndClaims.vue?vue&type=template&id=568e859c&scoped=true"
import script from "./NewDetailCasesAndClaims.vue?vue&type=script&lang=js"
export * from "./NewDetailCasesAndClaims.vue?vue&type=script&lang=js"
import style0 from "./NewDetailCasesAndClaims.vue?vue&type=style&index=0&id=568e859c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e859c",
  null
  
)

export default component.exports